/*
|--------------------------------------------------------------------------
| ZF Floating Product Bar
|--------------------------------------------------------------------------
| Shows a sticky Add to Cart / Buy Now bar on mobile.
| Uses the original Shopify buttons for all actions.
| No duplicate cart logic is implemented.
|--------------------------------------------------------------------------
*/

document.addEventListener("DOMContentLoaded", () => {

    const floating = document.querySelector(".zf-floating-product-bar");
    const buttons = document.querySelector("#zf-buy-buttons");

    if (!floating || !buttons) return;

    function toggleFloating() {

        const rect = buttons.getBoundingClientRect();

        const viewportHeight = window.innerHeight;

        if (rect.top > viewportHeight || rect.bottom < 0) {
            floating.classList.add("show");
        } else {
            floating.classList.remove("show");
        }

        console.log(
            "show?",
            rect.top > viewportHeight || rect.bottom < 0,
            floating.classList.contains("show")
        );

    }

    window.addEventListener("scroll", toggleFloating);
    window.addEventListener("resize", toggleFloating);


    // Show the floating CTA only when the original buy buttons
    // are outside the visible viewport.
    toggleFloating();

    // Trigger Shopify's original Add to Cart button.
    const floatingAtc = floating.querySelector(".zf-atc");

    if (floatingAtc) {
        floatingAtc.onclick = () => {
            document
                .querySelector("#zf-buy-buttons button[name='add']")
                ?.click();
        };
    }

    // Trigger Shopify's original Buy Now button.
    const floatingBuyNow = floating.querySelector(".zf-buy-now");

    if (floatingBuyNow) {
        floatingBuyNow.onclick = () => {
            document
                .querySelector("#zf-buy-buttons .shopify-payment-button__button")
                ?.click();
        };
    }
});